module.exports = __webpack_public_path__ + "img/file-document-outline.abaf872d.svg";